import React from 'react';
import { GeneralBox } from '../Shared/GeneralBox';
import ParticlesBG from "../Shared/ParticlesBG";
import '../Assets/Stylesheets/Pages/AiTools.scss';

// Import logos
import PromoEmail from '../Assets/Images/PromoEmail_tools.png';
import Blog from '../Assets/Images/Blog_tools.png';
import SocialPost from '../Assets/Images/SocialPost_tools.png';
import DigitalAds from '../Assets/Images/DigitalAds_tools.png';
import Logo from '../Assets/Images/Logo_tools.png';
import More from '../Assets/Images/More_logo.png';

const tools = [
  { title: "PROMOTIONAL EMAIL GENERATOR", link: "/promotional-email-generator", imageSrc: PromoEmail, description: "Create engaging promotional emails that convert leads into customers" },
  { title: "BLOG ARTICLE GENERATOR", link: "/blog-article-generator", imageSrc: Blog, description: "Generate SEO-optimized blog content to attract and engage your audience" },
  { title: "SOCIAL MEDIA POST GENERATOR", link: "/social-media-post-generator", imageSrc: SocialPost, description: "Design eye-catching social posts that boost engagement and reach" },
  { title: "DIGITAL AD GENERATOR", link: "/digital-ad-generator", imageSrc: DigitalAds, description: "Create high-converting digital ads for various platforms and formats" },
  { title: "LOGO GENERATOR", link: "/logo-generator", imageSrc: Logo, description: "Design professional logos that capture your brand's identity" },
  { title: "MORE", link: "/more-tools", imageSrc: More, description: "Explore additional AI-powered tools to enhance your marketing strategy" }
];

export default function AiTools() {
  // Split tools into two rows
  const firstRowTools = tools.slice(0, 3);
  const secondRowTools = tools.slice(3, 6);

  return (
    <div id="aitools-page">
      <section className="aitools-header">
        <div className="particles circle-bg">
          <div className="container">
            <div className="title-box">
              <h1>
                <span className="color-font">MARKETING TOOLS</span>
              </h1>
            </div>
          </div>

          <ParticlesBG />
          
          <div className="gradient-circle"></div>
          <div className="gradient-circle two"></div>
        </div>
      </section>
      
      <section className="services">
        <div className="container">
          <div className="aitools-intro">
            <p>
              AI-powered marketing tools help businesses create content and engage
              customers more efficiently.
              <span className="highlight"> These tools are launching soon</span> —
              explore what's coming below.
            </p>
          </div>
          <h2><span className="color-font">Our Tools</span></h2>
          
          {/* First row of tools */}
          <div className="box-column-container">
            {firstRowTools.map((tool, index) => (
              <div key={index} className="box-column">
                <GeneralBox
                  title={tool.title}
                  link={tool.link}
                  imageSrc={tool.imageSrc}
                  description={tool.description}
                  className="homepage-box"
                />
              </div>
            ))}
          </div>
          
          {/* Second row of tools */}
          <div className="box-column-container second-row">
            {secondRowTools.map((tool, index) => (
              <div key={index} className="box-column">
                <GeneralBox
                  title={tool.title}
                  link={tool.link}
                  imageSrc={tool.imageSrc}
                  description={tool.description}
                  className="homepage-box"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}